import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useTranslation } from 'react-i18next'

import Table from 'components/Shared/TableNew/Index'
import TableHead from 'components/Shared/TableNew/TableHead'
import TableBody from 'components/Shared/TableNew/TableBody'
import TableRow from 'components/Shared/TableNew/TableRow'
import TableCell from 'components/Shared/TableNew/TableCell'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import { userTimeZoneFormat } from 'utils/time'
import colors from 'components/utils/colors'
import { ACTION_COLOR_MAP } from 'constants/colorMaps'
import Tooltip from 'components/Shared/Tooltip/Index'
import IconLink from 'components/Shared/IconLink/Index'
import NoData from 'components/Shared/NoData/Index'

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  box-sizing: border-box;
  border-radius: 3px;
  flex-direction: column;
  background-color: #fff;
  padding: 10px 16px 10px 16px;
`

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.type === 'success' ? colors.success30 : colors.alert70};
  margin-bottom: 15px;
`
const StyledTableCell = styled.div`
  color: ${props => props.color};
`

const LastRequestStatusTable = ({ title, fetching, userTimeZone, items, type, tooltipText, tooltipId }) => {
  const { t } = useTranslation()

  if (!items) {
    return null
  }

  return (
    <StyledWrapper data-test='last-request-status'>
      <LoadingIndicator loading={fetching} small />
      <Title type={type} data-test='last-request-status-title'>
        {title}
        {tooltipText && (
          <>
            <IconLink
              data-tooltip-content={tooltipText}
              data-tooltip-id={tooltipId}
              iconName='icon-help-16'
            />
            <Tooltip id={tooltipId} />
          </>
        )}
      </Title>

      <Table width='100%'>
        <TableHead>
          <TableRow>
            <TableCell>{t('dashboardPage.action')}</TableCell>
            <TableCell>{t('dashboardPage.time')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody clickable={false} hoverable={false}>
          {items.map(i => {
            const time = (i.time === 'no data' || i.time === null) ? <NoData /> : userTimeZoneFormat(userTimeZone, i.time)

            return (
              <TableRow key={i.action}>
                <TableCell>
                  <StyledTableCell color={ACTION_COLOR_MAP[i.action]}>{i.action}</StyledTableCell>
                </TableCell>
                <TableCell>{time}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </StyledWrapper>
  )
}

LastRequestStatusTable.propTypes = {
  userTimeZone: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.array,
  fetching: PropTypes.bool,
  type: PropTypes.string,
  tooltipText: PropTypes.string,
  tooltipId: PropTypes.string,
}

export default LastRequestStatusTable
